/* ==========================================================================
   TNF · Barrierefreiheit (Verhalten)
   --------------------------------------------------------------------------
   Vier Aufgaben, jede fuer sich abgeschlossen. Keine greift in Theme-Interna
   ein - alles laeuft ueber Klassen und Attribute, die ohnehin im DOM stehen.

   1. Warenkorb-Schubfach als echter Dialog (Fokus, Esc, Tab bleibt drin)
   2. Wunschlisten-Herz meldet seinen Zustand an Screenreader
   3. Slideshow: Pause-Knopf, bei "reduzierte Bewegung" kein Autoplay
   4. Slider allgemein: ausgeblendete Folien nicht per Tab erreichbar,
      fehlerhafte ARIA-Rollen von Slick entfernt
   ========================================================================== */
(function () {
  'use strict';

  var FOKUSSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function sichtbar(el) {
    if (!el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  /* --------------------------------------- 1 · Schubfaecher als Dialog

     Halo oeffnet Warenkorb und Handy-Menue, indem es eine Klasse an <body>
     haengt ("cart-sidebar-show" bzw. "menu_open"). Wir beobachten genau diese
     Klassen - egal, WER sie setzt.

     Vorher: Fokus blieb hinter dem Schubfach, Esc tat nichts, Tab lief in
     die Seite dahinter. Das Handy-Menue hatte dieselben Luecken wie der
     Warenkorb (nachgemessen 21.09.2026 bei 390 px Breite), deshalb laufen
     beide jetzt ueber denselben Code. */
  function schubfach(opt) {
    var el = document.querySelector(opt.panel);
    if (!el) return;
    var vorherFokus = null;
    var offen = false;

    if (!el.hasAttribute('role')) el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    if (opt.name && !el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
      el.setAttribute('aria-label', opt.name);
    }

    function schliessKnopf() {
      var liste = el.querySelectorAll(opt.close);
      for (var i = 0; i < liste.length; i++) if (sichtbar(liste[i])) return liste[i];
      return liste[0] || null;
    }

    function ausloeser() {
      return opt.trigger ? document.querySelectorAll(opt.trigger) : [];
    }

    function zustand(an) {
      Array.prototype.forEach.call(ausloeser(), function (t) {
        t.setAttribute('aria-expanded', an ? 'true' : 'false');
        if (el.id) t.setAttribute('aria-controls', el.id);
        /* Das Theme nennt den Menue-Knopf nur "menu" (englisch, klein). */
        if (opt.triggerName && t.getAttribute('aria-label') !== opt.triggerName) {
          t.setAttribute('aria-label', opt.triggerName);
        }
      });
    }

    function hinein() {
      var k = schliessKnopf();
      (k && sichtbar(k) ? k : el).focus({ preventScroll: true });
    }

    function oeffnen() {
      offen = true;
      vorherFokus = document.activeElement;
      zustand(true);
      hinein();
      /* Das Schubfach blendet mit einer Transition ein - im allerersten
         Moment ist es noch "hidden" und nimmt keinen Fokus an. */
      [40, 120, 300, 600].forEach(function (ms) {
        setTimeout(function () {
          if (offen && !el.contains(document.activeElement)) hinein();
        }, ms);
      });
    }

    function geschlossen() {
      offen = false;
      zustand(false);
      if (vorherFokus && document.contains(vorherFokus) && typeof vorherFokus.focus === 'function') {
        vorherFokus.focus({ preventScroll: true });
      }
      vorherFokus = null;
    }

    zustand(document.body.classList.contains(opt.klasse));

    new MutationObserver(function () {
      var jetzt = document.body.classList.contains(opt.klasse);
      if (jetzt && !offen) oeffnen();
      else if (!jetzt && offen) geschlossen();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (e) {
      if (!offen) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        var k = schliessKnopf();
        if (k) { e.preventDefault(); k.click(); }
        return;
      }

      if (e.key !== 'Tab') return;
      var liste = Array.prototype.filter.call(el.querySelectorAll(FOKUSSIERBAR), sichtbar);
      if (!liste.length) { e.preventDefault(); return; }
      var erstes = liste[0], letztes = liste[liste.length - 1];

      if (!el.contains(document.activeElement)) {
        e.preventDefault(); erstes.focus(); return;
      }
      if (e.shiftKey && (document.activeElement === erstes || document.activeElement === el)) {
        e.preventDefault(); letztes.focus();
      } else if (!e.shiftKey && document.activeElement === letztes) {
        e.preventDefault(); erstes.focus();
      }
    });
  }

  function schubfachEinrichten() {
    schubfach({
      panel: '#halo-cart-sidebar',
      klasse: 'cart-sidebar-show',
      close: '[data-close-cart-sidebar]',
      trigger: 'a.header__icon--cart'
    });
    schubfach({
      panel: '#navigation-mobile',
      klasse: 'menu_open',
      close: '.halo-sidebar-close',
      trigger: '.mobileMenu-toggle',
      triggerName: 'Menü öffnen',
      name: 'Menü'
    });
  }

  /* -------------------------------------------- 2 · Wunschlisten-Herz

     Halo haengt "wishlist-added" an den Knopf. Sehende erkennen das am
     vollen Herz; ein Screenreader hoerte bisher immer nur "Zur Wunschliste
     hinzufuegen". Jetzt ist das Herz ein Umschalter mit Zustand:
     "Auf die Wunschliste, Umschalter, gedrueckt". */
  function herzAbgleichen(btn) {
    var an = btn.classList.contains('wishlist-added');
    var soll = an ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== soll) btn.setAttribute('aria-pressed', soll);
    if (!btn.classList.contains('tnfp-wish') && btn.getAttribute('aria-label') !== 'Auf die Wunschliste') {
      btn.setAttribute('aria-label', 'Auf die Wunschliste');
    }
  }

  function alleHerzen(wurzel) {
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('[data-wishlist]'), herzAbgleichen);
  }

  function herzenEinrichten() {
    alleHerzen();
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var m = liste[i];
        if (m.type === 'attributes') {
          if (m.target.matches && m.target.matches('[data-wishlist]')) herzAbgleichen(m.target);
        } else if (m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches('[data-wishlist]')) herzAbgleichen(n);
            else if (n.querySelector('[data-wishlist]')) alleHerzen(n);
          }
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------- 3 + 4 · Slider (Slick)

     Slick setzt Rollen, die nicht zusammenpassen (listbox ohne Namen,
     option mit aria-selected an Folien, tablist mit presentation-Kindern),
     und versteckt Folien vor Screenreadern, laesst ihre Links aber per Tab
     erreichbar. Beides raeumen wir nach jedem Folienwechsel auf. */
  var REDUZIERT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sliderAufraeumen(el) {
    var spur = el.querySelector('.slick-track');
    if (spur) { spur.removeAttribute('role'); }

    /* Folien sind die direkten Kinder der Spur - Halo gibt ihnen nicht immer
       die Klasse .slick-slide. */
    var folien = spur ? spur.children : el.querySelectorAll('.slick-slide');
    Array.prototype.forEach.call(folien, function (folie) {
      folie.removeAttribute('role');
      folie.removeAttribute('aria-selected');
      folie.removeAttribute('aria-describedby');
      var versteckt = folie.getAttribute('aria-hidden') === 'true';
      Array.prototype.forEach.call(folie.querySelectorAll(FOKUSSIERBAR + ', [data-tnf-tab]'), function (f) {
        if (versteckt) {
          if (!f.hasAttribute('data-tnf-tab')) f.setAttribute('data-tnf-tab', f.getAttribute('tabindex') || '');
          f.setAttribute('tabindex', '-1');
        } else if (f.hasAttribute('data-tnf-tab')) {
          var alt = f.getAttribute('data-tnf-tab');
          if (alt) f.setAttribute('tabindex', alt); else f.removeAttribute('tabindex');
          f.removeAttribute('data-tnf-tab');
        }
      });
    });

    /* Auch verschachtelte Folien-Huellen tragen "option" - weg damit. */
    Array.prototype.forEach.call(el.querySelectorAll('[role="option"]'), function (o) {
      o.removeAttribute('role');
      o.removeAttribute('aria-selected');
    });

    var punkte = el.querySelector('.slick-dots');
    if (punkte) {
      punkte.removeAttribute('role');
      var knoepfe = punkte.querySelectorAll('button');
      Array.prototype.forEach.call(punkte.querySelectorAll('li'), function (li) {
        li.removeAttribute('role');
        li.removeAttribute('aria-hidden');
        li.removeAttribute('aria-selected');
        li.removeAttribute('aria-controls');
      });
      Array.prototype.forEach.call(knoepfe, function (b, i) {
        b.removeAttribute('role');
        b.removeAttribute('aria-selected');
        b.removeAttribute('aria-controls');
        b.setAttribute('aria-label', 'Folie ' + (i + 1) + ' von ' + knoepfe.length);
        var aktiv = b.parentElement && b.parentElement.classList.contains('slick-active');
        if (aktiv) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        b.removeAttribute('tabindex');
      });
    }
  }

  var PAUSE_SVG =
    '<svg class="tnf-ico-pause" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>' +
    '<svg class="tnf-ico-play" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';

  function pauseKnopf($, el) {
    var opt;
    try { opt = $(el).slick('getSlick').options; } catch (e) { return; }
    if (!opt || !opt.autoplay || el.querySelector('.tnf-slide-pause')) return;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'tnf-slide-pause';
    knopf.setAttribute('aria-label', 'Slideshow anhalten');
    knopf.setAttribute('aria-pressed', 'false');
    knopf.innerHTML = PAUSE_SVG;

    /* Slick pausiert bei Mauszeiger/Fokus und laeuft danach selbst wieder
       an. Ein gedrueckter Pause-Knopf muss aber stehen bleiben - deshalb
       schalten wir Autoplay als Option ab, nicht nur voruebergehend. */
    function setzen(angehalten) {
      knopf.setAttribute('aria-pressed', angehalten ? 'true' : 'false');
      knopf.setAttribute('aria-label', angehalten ? 'Slideshow abspielen' : 'Slideshow anhalten');
      $(el).slick('slickSetOption', 'autoplay', !angehalten, false);
      $(el).slick(angehalten ? 'slickPause' : 'slickPlay');
    }

    knopf.addEventListener('click', function () {
      setzen(knopf.getAttribute('aria-pressed') !== 'true');
    });

    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.appendChild(knopf);

    if (REDUZIERT) setzen(true);
  }

  function sliderEinrichten() {
    var $ = window.jQuery;
    var alle = document.querySelectorAll('.slick-initialized');
    Array.prototype.forEach.call(alle, function (el) {
      sliderAufraeumen(el);
      if ($ && el.closest('.sections-slide-show, .slideshow')) pauseKnopf($, el);
      if ($ && !el.__tnfA11y) {
        el.__tnfA11y = true;
        /* Slick schreibt seine ARIA-Attribute NACH dem afterChange-Ereignis
           neu (initADA). Deshalb erst im naechsten Takt aufraeumen, sonst
           ueberschreibt Slick unsere Korrektur sofort wieder. */
        $(el).on('afterChange setPosition init reInit', function () {
          setTimeout(function () { sliderAufraeumen(el); }, 0);
        });
      }
    });
  }

  /* ------------------------------------------ 5 · Pfeile an Produkt-Slidern

     Die Pfeile von "Neu im Shop" & Co. stehen auf halber Hoehe des ganzen
     Sliders (Theme-Einstellung). Am Handy ist die Kachel durch den Text
     viel hoeher als breit - die halbe Hoehe liegt dann nicht mehr auf dem
     Bild, sondern mitten im Produkttitel, und der Pfeil deckt dessen Anfang
     zu (gemeldet 22.09.2026, "TNF+" war nur halb lesbar).

     Deshalb: am Handy den Pfeil auf die Mitte des Produktbildes setzen.
     Neu gemessen bei jedem Folienwechsel und wenn sich die Breite aendert. */
  var HANDY = window.matchMedia ? window.matchMedia('(max-width:767px)') : null;

  function pfeileSetzen(el) {
    var pfeile = el.querySelectorAll(':scope > .slick-arrow');
    if (!pfeile.length) return;
    if (!HANDY || !HANDY.matches) {
      Array.prototype.forEach.call(pfeile, function (p) { p.style.removeProperty('top'); });
      return;
    }
    var bild = el.querySelector('.slick-active .card-media') ||
               el.querySelector('.slick-active .card-product') ||
               el.querySelector('.card-media');
    if (!bild) return;
    var mitte = bild.getBoundingClientRect().top - el.getBoundingClientRect().top +
                bild.getBoundingClientRect().height / 2;
    if (mitte <= 0) return;
    Array.prototype.forEach.call(pfeile, function (p) {
      p.style.setProperty('top', Math.round(mitte) + 'px', 'important');
    });
  }

  function pfeileEinrichten() {
    var $ = window.jQuery;
    Array.prototype.forEach.call(document.querySelectorAll('.products-carousel.slick-initialized'), function (el) {
      pfeileSetzen(el);
      if ($ && !el.__tnfPfeile) {
        el.__tnfPfeile = true;
        $(el).on('setPosition afterChange', function () {
          setTimeout(function () { pfeileSetzen(el); }, 0);
        });
      }
    });
  }

  function start() {
    schubfachEinrichten();
    herzenEinrichten();
    sliderEinrichten();
    /* Das Theme startet die Slider erst nach dem Laden aller Apps - je nach
       Verbindung nach 2 oder erst nach 10 Sekunden. Zwei feste Nachversuche
       (1,5 s und 4 s) reichten nicht: auf langsamen Verbindungen fehlte der
       Pause-Knopf dann ganz. Deshalb: alle 500 ms nachsehen, bis zu 30 s,
       und aufhoeren, sobald die Slideshow ihren Knopf hat. */
    var versuche = 0;
    var uhr = setInterval(function () {
      sliderEinrichten();
      pfeileEinrichten();
      versuche++;
      var fertig = document.querySelector('.tnf-slide-pause') ||
                   !document.querySelector('.sections-slide-show, .slideshow');
      if (fertig || versuche > 60) clearInterval(uhr);
    }, 500);
    window.addEventListener('load', function () { sliderEinrichten(); pfeileEinrichten(); });
    /* Bilder laden nach - dann stimmt die gemessene Mitte erst danach. */
    window.addEventListener('resize', pfeileEinrichten);
    setTimeout(pfeileEinrichten, 6000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
